import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styles from './RadioInput.module.css';
export function RadioInput(props) {
    return (_jsxs("button", { type: 'button', className: [
            styles.container,
            styles.default,
            props.selected ? styles.selected : '',
            props.disabled ? styles.disabled : '',
            props.readOnly ? styles.readOnly : '',
        ]
            .filter(Boolean)
            .join(' '), "data-testid": `button-${props.dataTestId}-radio-input`, onClick: !props.disabled && !props.readOnly ? props.onClick : undefined, onMouseEnter: () => { }, disabled: props.disabled, "aria-pressed": props.selected, children: [_jsx("span", { className: styles.radio, "aria-hidden": 'true', children: _jsx("span", { className: styles.dot }) }), props.label && (_jsx("span", { className: styles.label, "data-testid": `span-${props.dataTestId}-radio-input-label`, children: props.label }))] }));
}
